import { createContext, useContext, useState } from "react";

/** Whether a rail takes room right of the page card, so the card keeps the gap to it rather than the edge gutter. */
export const PageRailContext = createContext(false);

/** Where a rail that can take room right of the page card reports whether it does; null when it unmounts. */
export const ReportPageRailContext = createContext<
  ((isTakingRoom: boolean | null) => void) | null
>(null);

/** For a shell that lays a rail out beside its card: a rail that never reports, like the filters rail, takes room. */
export const usePageRail = (hasRail: boolean) => {
  const isBesideOuterRail = useContext(PageRailContext);
  const [reported, setReported] = useState<boolean | null>(null);
  return {
    isBesideRail: isBesideOuterRail || (hasRail && (reported ?? true)),
    reportRail: setReported,
  };
};
